<div class="wrap">
  <ng-container *ngIf="!isReset">
    <p>Souhaitez-vous retourner <br>à la liste des menus par défaut ?</p>
    <div class="btn_action">
      <button class="no" (click)="dialogRef.close()" routerLinkActive="router-link-active"
        mat-dialog-close>Annuler</button>
      <!-- <button type="submit" [routerLink]="['/home']" routerLinkActive="router-link-active">Confirmer</button> -->
      <button type="submit" (click)="confirmReset()">Confirmer</button>
    </div>

  </ng-container>

  <div class="validation" *ngIf="isReset">
    <div class="validation_reset">
      <div class="check">
        <span class="icon-line line-tip"></span>
        <span class="icon-line line-long"></span>
        <div class="icon-circle"></div>
        <div class="icon-fix"></div>
      </div>
    </div>
    <p>La liste des menus par defaut a été appliquée</p>
  </div>
</div>